import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { autorun, configure, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Box, Snackbar, StyleRules, withStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { StyledComponentProps } from '@material-ui/styles/withStyles';
import { appStore, authService } from './index';
import { AppTheme, ConfirmationDialog, HeaderNavigation, HeadLine, Layout, Login } from './Components';

import './App.css';

const styles: StyleRules = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
};

configure({
    enforceActions: 'never',
});

@observer
class App extends React.Component<StyledComponentProps> {
    @observable open = false;

    constructor (props: StyledComponentProps) {
        super(props);
        makeObservable(this);
    }

    handleClick = () => {
        this.open = !this.open;
    };

    componentWillUnmount () {
        authService.stopTokenAutoRefresh();
    }

    render () {
        const { classes } = this.props;
        const { currentUser, isTokenValid } = authService;

        if (!currentUser || !isTokenValid) {
            return <Login/>;
        }

        const userName = currentUser.username || currentUser.name;

        return (
            <AppTheme>
                <Box className={classes!.main}>
                    <HeaderNavigation userName={userName}/>
                    <Router>
                        <HeadLine open={this.open} onClick={this.handleClick}/>
                        <Layout open={this.open}/>
                    </Router>
                    <ConfirmationDialog/>
                </Box>
                {Array.from(appStore.notifications.keys()).map(key => {
                    const n = appStore.notifications.get(key);
                    if (!n) return null;
                    return (
                        <Snackbar
                            key={key}
                            open={true}
                            autoHideDuration={5000}
                            onClose={appStore.hideNotification(key)}>
                            <Alert onClose={appStore.hideNotification(key)} severity={n.type}>
                                {n.label}
                                {n.body}
                            </Alert>
                        </Snackbar>
                    );
                })}
            </AppTheme>
        );
    }
}

export default withStyles(styles)(App);
